export default {
    data() {
        return {
            help_drawer_open: false,
            help_previous_focus: null,

            help_loading_article: false,
            help_search_loading: false,
            help_browse_loading: false,
            help_nav_loading: false,

            help_error: '',

            help_search_query: '',
            help_search_results: [],

            help_browse_categories: [],
            help_nav_tree: typeof window !== 'undefined' && window.vClientHelpChrome && Array.isArray(window.vClientHelpNavTree)
                ? window.vClientHelpNavTree
                : (typeof window !== 'undefined' && window.vAdmin2026Chrome && Array.isArray(window.vAdmin2026HelpNavTree)
                    ? window.vAdmin2026HelpNavTree
                    : []),
            help_open_root_key: null,
            help_ignore_dialog_close_until: 0,
            help_debug_enabled: false,

            help_active_article: null,
            help_article_request_id: 0,
            help_image_gallery: [],
            help_image_index: -1,
            help_manual_editor_open: false,
            help_manual_editor_loading: false,
            help_manual_editor_saving: false,
            help_manual_editor_error: '',
            help_manual_editor_warnings: [],
            help_manual_editor_form: {
                title: '',
                summary: '',
                status: 'published',
                include_system_reference: true,
                body: '',
            },

            help_search_timer: null,
        };
    },

    computed: {
        help_enabled() {
            try {
                return !!window.vHelpEnabled;
            } catch (e) {
                return false;
            }
        },

        help_content_enabled() {
            try {
                return typeof window.vHelpContentEnabled === 'undefined'
                    ? true
                    : !!window.vHelpContentEnabled;
            } catch (e) {
                return true;
            }
        },

        help_temporarily_unavailable() {
            try {
                return !!window.vAdmin2026HelpTemporarilyUnavailable;
            } catch (e) {
                return false;
            }
        },

        help_route_context() {
            try {
                return window.vHelpRoute || {};
            } catch (e) {
                return {};
            }
        },

    },
    watch: {
        modalAsset1Open(open) {
            if (!open && this.help_image_gallery.length) {
                this.help_image_gallery = [];
                this.help_image_index = -1;
            }
        },
    },
    mounted() {
        try {
            const host = (window && window.location && window.location.hostname ? window.location.hostname : '').toString().toLowerCase();
            this.help_debug_enabled =
                host === 'localhost' ||
                host === '127.0.0.1' ||
                host.endsWith('.test') ||
                host.endsWith('.local') ||
                host.endsWith('.localhost');
        } catch (e) {
            this.help_debug_enabled = false;
        }

        if (typeof document !== 'undefined') {
            document.addEventListener('keydown', this.help_handleDrawerKeydown, true);
        }
    },

    beforeUnmount() {
        if (typeof document !== 'undefined') {
            document.removeEventListener('keydown', this.help_handleDrawerKeydown, true);
        }

        this.help_resetBackdropPointer();
    },

    methods: {
        help_apiUrl(path) {
            return (window.vClientHelpChrome
                ? (window.vClientHelpBasePath || '/account/help') + '/api/'
                : '/pono-admin/help/api/') + path;
        },

        help_apiParameters(parameters = {}) {
            if (window.vClientHelpChrome && window.vClientHelpAccessToken) {
                return { ...parameters, access: window.vClientHelpAccessToken };
            }
            return window.vClientHelpChrome && Number.isInteger(window.vClientHelpPreviewUserId) && window.vClientHelpPreviewUserId > 0
                ? { ...parameters, u: window.vClientHelpPreviewUserId }
                : parameters;
        },

        help_debugLog(message, payload = null) {
            if (!this.help_debug_enabled) return;
            const ts = (new Date()).toISOString();
            if (payload === null || payload === undefined) {
                console.log(`[HelpDrawer ${ts}] ${message}`);
                return;
            }
            console.log(`[HelpDrawer ${ts}] ${message}`, payload);
        },

        help_openDrawer(mode = 'current', help_id = null, anchor = null, event = null) {
            try {
                if (event && typeof event.preventDefault === 'function') event.preventDefault();
                if (event && typeof event.stopPropagation === 'function') event.stopPropagation();
            } catch (e) {}

            if (!this.help_enabled) return;

            if (window.vAdmin2026Chrome) this.help_previous_focus = document.activeElement;

            // Defer open so the triggering click cannot be treated as an outside-click close.
            setTimeout(() => {
                this.help_ignore_dialog_close_until = Date.now() + 500;
                this.help_drawer_open = true;
                this.help_error = '';
                this.help_open_root_key = null;
                this.help_debugLog('Opened help drawer', {
                    mode,
                    help_id: help_id || null,
                    ignore_dialog_close_until: this.help_ignore_dialog_close_until,
                });

                if (this.help_temporarily_unavailable) {
                    this.help_active_article = null;
                    this.help_error = '';
                    this.help_search_query = '';
                    this.help_search_results = [];
                    this.help_resetManualEditor();

                    // Keep the disabled topic menu populated without loading article content.
                    if (!this.help_nav_tree.length) {
                        this.help_loadNav(true);
                    }

                    return;
                }

                if (!this.help_content_enabled) {
                    this.help_active_article = null;
                    this.help_error = '';
                    this.help_search_query = '';
                    this.help_search_results = [];
                    this.help_resetManualEditor();
                    return;
                }

                // Always make sure nav tree is available for “full documentation”
                if (!this.help_nav_tree.length) {
                    this.help_loadNav();
                }

                // Focus the search box (small delay so the drawer is in DOM)
                try {
                    setTimeout(() => {
                        if (this.$refs.helpSearchInput) this.$refs.helpSearchInput.focus();
                    }, 50);
                } catch (e) {}

                if (mode === 'browse') {
                    this.help_showIndex();
                    return;
                }

                if (mode === 'article' && help_id) {
                    this.help_loadArticle(help_id, anchor);
                    return;
                }

                if (window.vAdmin2026Chrome || window.vClientHelpChrome) {
                    this.help_active_article = null;
                    this.help_showIndex();
                    return;
                }

                this.help_loadCurrent();
            }, 0);
        },

        async admin2026DismissIntroCard(cardKey, endpoint) {
            const key = (cardKey || '').toString().trim();
            const url = (endpoint || '').toString().trim();

            if (!key || !url) return;

            try {
                const res = await this.axios.post(url, { key });

                if (!(res && res.data && res.data.success)) {
                    throw new Error('Intro card dismissal failed.');
                }

                if (typeof document !== 'undefined') {
                    document.querySelectorAll('[data-admin2026-intro-card]').forEach((element) => {
                        if (element.getAttribute('data-admin2026-intro-card') === key) {
                            element.remove();
                        }
                    });
                }
            } catch (e) {
                if (typeof this.openModalWarning === 'function') {
                    this.openModalWarning('ERROR', 'There was a connection problem and the intro card could not be dismissed. Please try again.');
                }
            }
        },

        help_handleDialogClose(payload = null) {
            this.help_debugLog('Dialog @close fired', {
                payload,
                ignored: true,
            });
            // Ignore generic Headless UI close requests for this drawer.
            // Explicit Escape, backdrop, and button handlers own closing.
        },

        help_closeDrawer(reason = 'manual') {
            if (window.vClientHelpChrome && typeof this.closeAccount2026HelpGuidesDrawer === 'function') {
                this.closeAccount2026HelpGuidesDrawer();
                return;
            }
            this.help_debugLog('Closing help drawer', { reason });
            this.help_drawer_open = false;
            this.help_ignore_dialog_close_until = 0;
            this.help_resetBackdropPointer();
        },

        help_handleDrawerKeydown(event) {
            if (!event || !this.help_drawer_open) {
                return;
            }

            if (this.modalAsset13Open && this.modalAsset13Options?.helpPreview) {
                if (event.key === 'Escape') {
                    event.preventDefault();
                    event.stopPropagation();
                    event.stopImmediatePropagation();
                    this.closeModalAsset13();
                }
                return;
            }

            if (this.modalAsset1Open && this.help_image_gallery.length) {
                if (event.key === 'Escape') {
                    event.preventDefault();
                    event.stopPropagation();
                    event.stopImmediatePropagation();
                    this.closeModalAsset1();
                    return;
                }
                if (this.help_image_gallery.length < 2 || !['ArrowLeft', 'ArrowRight'].includes(event.key)
                    || event.altKey || event.ctrlKey || event.metaKey) return;

                const target = event.target;
                if (target && (['INPUT', 'TEXTAREA', 'SELECT'].includes(target.tagName) || target.isContentEditable)) return;

                event.preventDefault();
                event.stopPropagation();
                this.help_navigateImageGallery(event.key === 'ArrowRight' ? 1 : -1);
                return;
            }

            if (event.key !== 'Escape') {
                return;
            }

            if (typeof event.preventDefault === 'function') {
                event.preventDefault();
            }
            if (typeof event.stopPropagation === 'function') {
                event.stopPropagation();
            }
            if (typeof event.stopImmediatePropagation === 'function') {
                event.stopImmediatePropagation();
            }

            this.help_closeDrawer('escape');
        },

        help_backdropPointerIsPrimary(event) {
            return !!(
                event
                && event.target === event.currentTarget
                && (typeof event.button !== 'number' || event.button === 0)
                && (typeof event.isPrimary !== 'boolean' || event.isPrimary === true)
            );
        },

        help_handleBackdropPointerDown(event) {
            if (!this.help_backdropPointerIsPrimary(event)) {
                this.help_resetBackdropPointer();
                return;
            }

            this._helpBackdropPointer = {
                pointerId: typeof event.pointerId === 'number' ? event.pointerId : null,
                clientX: Number.isFinite(Number(event.clientX)) ? Number(event.clientX) : 0,
                clientY: Number.isFinite(Number(event.clientY)) ? Number(event.clientY) : 0,
                startedAt: Number.isFinite(Number(event.timeStamp)) ? Number(event.timeStamp) : Date.now(),
            };
        },

        help_handleBackdropPointerUp(event) {
            const pointer = this._helpBackdropPointer || null;

            this.help_resetBackdropPointer();

            if (!pointer || !this.help_drawer_open || !this.help_backdropPointerIsPrimary(event)) {
                return;
            }

            if (pointer.pointerId !== null && typeof event.pointerId === 'number' && event.pointerId !== pointer.pointerId) {
                return;
            }

            const clientX = Number.isFinite(Number(event.clientX)) ? Number(event.clientX) : 0;
            const clientY = Number.isFinite(Number(event.clientY)) ? Number(event.clientY) : 0;
            const endedAt = Number.isFinite(Number(event.timeStamp)) ? Number(event.timeStamp) : Date.now();

            if (Math.abs(clientX - pointer.clientX) > 6 || Math.abs(clientY - pointer.clientY) > 6 || Math.abs(endedAt - pointer.startedAt) > 750) {
                return;
            }

            this.help_closeDrawer('backdrop');
        },

        help_resetBackdropPointer() {
            this._helpBackdropPointer = null;
        },

        help_showIndex() {
            if (!this.help_content_enabled) return;

            if (window.vAdmin2026Chrome || window.vClientHelpChrome) {
                this.help_active_article = null;
            }

            this.help_search_query = '';
            this.help_search_results = [];
            this.help_error = '';
            this.help_open_root_key = null;
            this.help_resetManualEditor();

            if (!this.help_nav_tree.length && !this.help_nav_loading) {
                this.help_loadNav();
            }
        },

        async help_loadCurrent() {
            if (!this.help_enabled || !this.help_content_enabled) return;

            const ctx = this.help_route_context || {};
            const method = (ctx.method || 'GET').toString();
            const uri = (ctx.uri || '').toString();

            if (!uri) {
                this.help_error = 'Help cannot load for this page (missing route context).';
                return;
            }

            this.help_loading_article = true;
            this.help_error = '';
            this.help_resetManualEditor();

            try {
                const params = {
                    method,
                    uri,
                };

                const routeName = (ctx.route_name || ctx.name || '').toString();
                if (routeName) {
                    params.route_name = routeName;
                    params.name = routeName;
                }

                const path = (ctx.path || '').toString();
                if (path) {
                    params.path = path;
                }

                const fullPath = (ctx.full_path || ctx.fullPath || '').toString();
                if (fullPath) {
                    params.full_path = fullPath;
                }

                if (ctx.query && typeof ctx.query === 'object') {
                    params.query = ctx.query;
                }

                const explicitHelpId = (ctx.help_id || '').toString().trim();
                if (explicitHelpId) {
                    params.help_id = explicitHelpId;
                }

                const res = await this.axios.get('/pono-admin/help/api/current', {
                    params
                });

                if (res && res.data && res.data.success && res.data.article) {
                    this.help_active_article = res.data.article;
                    this.$nextTick(() => {
                        this.help_openNavForActiveArticle();
                        this.help_applyCustomFunctionalityAccordion();
                        this.help_applyDemoVideoIndexLink();
                    });

                    // Scroll to default anchor from route map if provided
                    const anchor = res.data.route && res.data.route.anchor ? res.data.route.anchor : null;
                    if (anchor) {
                        this.$nextTick(() => this.help_scrollToAnchor(anchor));
                    }
                } else {
                    this.help_error = 'Help could not be loaded for this page.';
                }
            } catch (e) {
                // Local dev may hit this while docs are still incomplete.
                this.help_error = 'Help is not available for this page yet.';
            } finally {
                this.help_loading_article = false;
            }
        },

        help_loadAudience(audience) {
            const articles = this.help_active_article?.audience_articles || {};
            if (articles[audience]) return this.help_loadArticle(articles[audience]);
        },

        help_openVideo(video) {
            if (!video?.src || typeof this.openModalAsset13 !== 'function') return;
            this.openModalAsset13(video.src, false, {
                title: video.title,
                poster: video.poster,
                audienceLabel: video.audience_label,
                aspectRatio: video.aspect_ratio,
                helpPreview: true,
            });
        },

        async help_loadArticle(help_id, anchor = null) {
            if (!this.help_enabled || !this.help_content_enabled) return;
            if (!help_id) return;

            const requestId = ++this.help_article_request_id;
            this.help_loading_article = true;
            this.help_error = '';
            this.help_resetManualEditor();
            let loaded = false;

            try {
                const res = await this.axios.get(this.help_apiUrl('article/' + encodeURIComponent(help_id)), { params: this.help_apiParameters() });
                if (requestId !== this.help_article_request_id) return;

                if (res && res.data && res.data.success && res.data.article) {
                    this.help_active_article = res.data.article;
                    loaded = true;
                    this.$nextTick(() => {
                        this.help_openNavForActiveArticle();
                        this.help_applyCustomFunctionalityAccordion();
                        this.help_applyDemoVideoIndexLink();
                    });
                } else {
                    this.help_error = 'That help article could not be loaded.';
                }
            } catch (e) {
                if (requestId === this.help_article_request_id) {
                    this.help_error = 'That help article could not be loaded.';
                }
            } finally {
                if (requestId === this.help_article_request_id) {
                    this.help_loading_article = false;
                }
            }

            if (loaded && anchor) {
                await this.$nextTick();
                this.help_scrollToAnchor(anchor);
            }
        },

        help_searchDebounced() {
            if (!this.help_enabled || !this.help_content_enabled) return;

            if (this.help_search_timer) {
                clearTimeout(this.help_search_timer);
            }

            this.help_search_timer = setTimeout(() => {
                this.help_searchNow();
            }, 250);
        },

        async help_searchNow() {
            if (!this.help_enabled || !this.help_content_enabled) return;

            const q = (this.help_search_query || '').trim();
            if (q.length < 2) {
                this.help_search_results = [];
                return;
            }

            this.help_search_loading = true;

            try {
                const res = await this.axios.get(this.help_apiUrl('search'), { params: this.help_apiParameters({ q }) });

                if (res && res.data && res.data.success) {
                    this.help_search_results = res.data.results || [];
                } else {
                    this.help_search_results = [];
                }
            } catch (e) {
                this.help_search_results = [];
            } finally {
                this.help_search_loading = false;
            }
        },

        async help_loadBrowse() {
            if (!this.help_enabled || !this.help_content_enabled) return;

            this.help_browse_loading = true;

            try {
                const res = await this.axios.get(this.help_apiUrl('browse'), { params: this.help_apiParameters() });

                if (res && res.data && res.data.success) {
                    this.help_browse_categories = res.data.categories || [];
                } else {
                    this.help_browse_categories = [];
                }
            } catch (e) {
                this.help_browse_categories = [];
            } finally {
                this.help_browse_loading = false;
            }
        },

        async help_loadNav(allowUnavailablePreview = false) {
            if (!this.help_enabled || (!this.help_content_enabled && !allowUnavailablePreview)) return;

            this.help_nav_loading = true;

            try {
                const res = await this.axios.get(this.help_apiUrl('nav'), { params: this.help_apiParameters() });
                if (res && res.data && res.data.success) {
                    this.help_nav_tree = Array.isArray(res.data.tree) ? res.data.tree : [];
                } else {
                    this.help_nav_tree = [];
                }
                this.help_open_root_key = null;
                this.$nextTick(() => this.help_openNavForActiveArticle());
            } catch (e) {
                this.help_nav_tree = [];
                this.help_open_root_key = null;
            } finally {
                this.help_nav_loading = false;
            }
        },

        help_rootNodeKey(node, nodeIndex = 0) {
            const index = Number.isInteger(nodeIndex) ? nodeIndex : 0;
            const label = node && node.label ? node.label.toString() : 'root';
            return `help-root-${index}-${label}`;
        },

        help_toggleRoot(rootKey) {
            const key = rootKey ? rootKey.toString() : '';
            if (!key) {
                this.help_open_root_key = null;
                return;
            }

            this.help_open_root_key = this.help_open_root_key === key ? null : key;
        },

        help_openNavForActiveArticle() {
            const helpId = this.help_active_article && this.help_active_article.help_id
                ? this.help_active_article.help_id.toString()
                : '';
            if (!helpId || !Array.isArray(this.help_nav_tree) || !this.help_nav_tree.length) {
                return;
            }

            const rootKey = this.help_findRootKeyForHelpId(this.help_nav_tree, helpId);
            if (rootKey) {
                this.help_open_root_key = rootKey;
            }
        },

        help_findRootKeyForHelpId(nodes, helpId) {
            if (!Array.isArray(nodes) || !helpId) {
                return null;
            }

            for (let index = 0; index < nodes.length; index += 1) {
                const node = nodes[index];
                if (this.help_nodeContainsHelpId(node, helpId)) {
                    return this.help_rootNodeKey(node, index);
                }
            }

            return null;
        },

        help_nodeContainsHelpId(node, helpId) {
            if (!node || !helpId) {
                return false;
            }

            const nodeHelpId = node.help_id ? node.help_id.toString() : '';
            if (nodeHelpId === helpId) {
                return true;
            }

            const children = Array.isArray(node.children) ? node.children : [];
            return children.some((child) => this.help_nodeContainsHelpId(child, helpId));
        },

        help_scrollToAnchor(anchor) {
            try {
                if (!anchor) return;
                const el = anchor === 'help-demo-videos'
                    ? this.$refs.helpDemoVideos
                    : this.$refs.helpContent?.querySelector('#' + CSS.escape(anchor));
                if (!el) return;

                // If the target lives inside a collapsed section, open it first.
                const parentDetails = el.closest('details');
                if (parentDetails) {
                    parentDetails.open = true;
                }
                if (el.tagName && el.tagName.toLowerCase() === 'details') {
                    el.open = true;
                }

                // Scroll inside the drawer panel
                el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            } catch (e) {}
        },

        help_applyDemoVideoIndexLink() {
            if (!(window.vAdmin2026Chrome || window.vClientHelpChrome) || !this.help_active_article?.videos?.length) return;

            const content = this.$refs.helpContent;
            const index = content?.querySelector('#in-this-guide')?.nextElementSibling;
            if (index?.tagName !== 'UL' || index.querySelector('a[href="#help-demo-videos"]')) return;

            const item = document.createElement('li');
            const link = document.createElement('a');
            link.setAttribute('href', '#help-demo-videos');
            link.textContent = 'Watch demo videos';
            item.appendChild(link);
            index.appendChild(item);
        },

        help_applyCustomFunctionalityAccordion() {
            try {
                const article = this.help_active_article || null;
                if (!article || article.help_id !== 'admin.custom.project-functionality') {
                    return;
                }

                const container = this.$refs.helpContent;
                if (!container) return;

                // Prevent duplicate wrapping if this runs more than once for the same render.
                if (container.dataset.helpAccordionApplied === '1') {
                    return;
                }

                const children = Array.from(container.children || []);
                if (!children.length) return;

                const hasTopLevelSections = children.some((node) => {
                    return node.tagName && node.tagName.toLowerCase() === 'h2';
                });
                if (!hasTopLevelSections) return;

                const fragment = document.createDocumentFragment();
                let index = 0;

                while (index < children.length) {
                    const node = children[index];
                    const tag = node.tagName ? node.tagName.toLowerCase() : '';

                    // Keep non-section content (intro title/paragraphs) as-is.
                    if (tag !== 'h2') {
                        fragment.appendChild(node);
                        index++;
                        continue;
                    }

                    const details = document.createElement('details');
                    details.className = 'pono-help-collapsible';
                    details.open = false;

                    const headingId = (node.getAttribute('id') || '').trim();
                    if (headingId) {
                        details.id = headingId;
                    }

                    const summary = document.createElement('summary');
                    summary.className = 'pono-help-collapsible-summary';
                    summary.textContent = (node.textContent || '').trim();
                    details.appendChild(summary);

                    const body = document.createElement('div');
                    body.className = 'pono-help-collapsible-body';

                    index++;
                    while (index < children.length) {
                        const nextNode = children[index];
                        const nextTag = nextNode.tagName ? nextNode.tagName.toLowerCase() : '';
                        if (nextTag === 'h2') {
                            break;
                        }

                        body.appendChild(nextNode);
                        index++;
                    }

                    details.appendChild(body);
                    fragment.appendChild(details);
                }

                container.innerHTML = '';
                container.appendChild(fragment);
                container.dataset.helpAccordionApplied = '1';
            } catch (e) {}
        },

        help_handleContentClick(event) {
            try {
                const a = event.target ? event.target.closest('a') : null;
                if (!a) return;

                const href = a.getAttribute('href') || '';

                if ((window.vAdmin2026Chrome || window.vClientHelpChrome) && /^\/images\/help\/[a-z0-9_-]+\/[a-f0-9]{64}\.(?:jpg|png|webp)$/.test(href)) {
                    event.preventDefault();
                    const media = a.closest('.pono-help-media');
                    const links = (media ? Array.from(media.querySelectorAll('a[href^="/images/help/"]')) : [a])
                        .filter(link => /^\/images\/help\/[a-z0-9_-]+\/[a-f0-9]{64}\.(?:jpg|png|webp)$/.test(link.getAttribute('href') || ''));
                    const gallery = links.map(link => ({
                        src: link.getAttribute('href') || '',
                        name: link.querySelector('img')?.getAttribute('alt') || 'Screenshot',
                        frame: link.classList.contains('pono-device-phone-capture') ? 'phone-capture'
                            : (link.classList.contains('pono-device-phone') ? 'phone' : ''),
                    }));
                    const index = links.indexOf(a);

                    if (gallery.length && index >= 0 && typeof this.openModalAsset1 === 'function') {
                        this.help_image_gallery = gallery;
                        this.help_image_index = index;
                        this.openModalAsset1(gallery[index].src, gallery[index].name, 0, '', { frame: gallery[index].frame });
                    }
                    return;
                }

                // 1) In-article anchors -> scroll inside drawer
                if (href.startsWith('#')) {
                    event.preventDefault();
                    const id = href.replace('#', '').trim();
                    if (id) this.help_scrollToAnchor(id);
                    return;
                }

                // 2) Clicking another help article link should open inside drawer (no navigation)
                const articlePrefix = window.vClientHelpChrome
                    ? (window.vClientHelpBasePath || '/account/help') + '/articles/'
                    : '/pono-admin/help/articles/';
                if (href.startsWith(articlePrefix)) {
                    event.preventDefault();
                    const parts = href.split(articlePrefix);
                    const rest = parts.length > 1 ? parts[1] : '';
                    const [helpIdPart, hashPart] = rest.split('#');
                    const nextHelpId = decodeURIComponent((helpIdPart || '').split('?')[0].trim());
                    const nextAnchor = hashPart ? hashPart.trim() : null;
                    if (nextHelpId) {
                        this.help_loadArticle(nextHelpId, nextAnchor);
                    }
                    return;
                }
            } catch (e) {}
        },

        help_navigateImageGallery(direction) {
            if (!this.modalAsset1Open || this.help_image_gallery.length < 2 || this.help_image_index < 0) return;

            const next = (this.help_image_index + Number(direction) + this.help_image_gallery.length) % this.help_image_gallery.length;
            this.help_image_index = next;
            const image = this.help_image_gallery[next];
            this.openModalAsset1(image.src, image.name, 0, '', { frame: image.frame });
        },

        help_resolvedArticleUrl(article = null, anchor = null) {
            const a = article || this.help_active_article;
            if (!a) return '';

            let baseUrl = '';
            if (a.help_url && a.help_url.toString().trim()) {
                baseUrl = a.help_url.toString().trim();
            } else if (a.help_id && a.help_id.toString().trim()) {
                baseUrl = '/pono-admin/help/articles/' + encodeURIComponent(a.help_id.toString().trim());
            }

            if (!baseUrl) return '';

            if (anchor) {
                return baseUrl + '#' + encodeURIComponent(anchor.toString().trim());
            }

            return baseUrl;
        },

        help_copyArticleLink(anchor = null) {
            const url = this.help_resolvedArticleUrl(this.help_active_article, anchor);
            if (!url) return;

            // Uses your existing app method (already in app.js)
            if (typeof this.copyToClipboard === 'function') {
                this.copyToClipboard(url, 'Help link copied');
            } else {
                // Fallback
                try {
                    navigator.clipboard.writeText(url);
                } catch (e) {}
            }
        },

        help_resetManualEditor() {
            this.help_manual_editor_open = false;
            this.help_manual_editor_loading = false;
            this.help_manual_editor_saving = false;
            this.help_manual_editor_error = '';
            this.help_manual_editor_warnings = [];
            this.help_manual_editor_form = {
                title: '',
                summary: '',
                status: 'published',
                include_system_reference: true,
                body: '',
            };
        },

        help_canEditManualArticle() {
            return !!(
                this.help_active_article
                && this.help_active_article.help_id
                && this.help_active_article.can_edit_manual_help
            );
        },

        async help_openManualEditor() {
            if (!this.help_canEditManualArticle()) return;

            const helpId = this.help_active_article.help_id.toString();
            this.help_manual_editor_open = true;
            this.help_manual_editor_loading = true;
            this.help_manual_editor_saving = false;
            this.help_manual_editor_error = '';
            this.help_manual_editor_warnings = [];

            try {
                const res = await this.axios.get('/pono-admin/help/api/manual-editor/' + encodeURIComponent(helpId));
                if (res && res.data && res.data.success) {
                    const showManualContent = Object.prototype.hasOwnProperty.call(res.data, 'show_manual_content')
                        ? !!res.data.show_manual_content
                        : res.data.status !== 'draft';
                    this.help_manual_editor_form = {
                        title: (res.data.title || '').toString(),
                        summary: (res.data.summary || '').toString(),
                        status: showManualContent ? 'published' : 'draft',
                        include_system_reference: !!res.data.include_system_reference,
                        body: (res.data.body || '').toString(),
                    };
                } else {
                    this.help_manual_editor_error = 'Manual help could not be loaded.';
                }
            } catch (e) {
                this.help_manual_editor_error = 'Manual help could not be loaded.';
            } finally {
                this.help_manual_editor_loading = false;
            }
        },

        help_cancelManualEditor() {
            this.help_resetManualEditor();
        },

        async help_saveManualEditor() {
            if (!this.help_canEditManualArticle()) return;

            const helpId = this.help_active_article.help_id.toString();
            this.help_manual_editor_saving = true;
            this.help_manual_editor_error = '';
            this.help_manual_editor_warnings = [];

            try {
                const res = await this.axios.post('/pono-admin/help/api/manual-editor/' + encodeURIComponent(helpId), {
                    title: this.help_manual_editor_form.title || '',
                    summary: this.help_manual_editor_form.summary || '',
                    status: this.help_manual_editor_form.status === 'draft' ? 'draft' : 'published',
                    include_system_reference: !!this.help_manual_editor_form.include_system_reference,
                    body: this.help_manual_editor_form.body || '',
                });

                if (res && res.data && res.data.success) {
                    this.help_manual_editor_warnings = Array.isArray(res.data.warnings) ? res.data.warnings : [];
                    this.help_manual_editor_open = false;
                    await this.help_loadArticle(helpId);
                    await this.help_loadNav();

                    const q = (this.help_search_query || '').trim();
                    if (q.length >= 2) {
                        await this.help_searchNow();
                    }
                } else {
                    this.help_manual_editor_error = 'Manual help could not be saved.';
                }
            } catch (e) {
                this.help_manual_editor_error = 'Manual help could not be saved.';
            } finally {
                this.help_manual_editor_saving = false;
            }
        },
    },
};
